"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIDE_GROUP_PATH = exports.HIDE_GROUP_PARENT_PATH = exports.SHOW_URL_GROUP_FILTER_PATH = exports.SHOW_URL_GROUP_PATH = exports.SHOW_GROUP_PATH = exports.FILTER_VALUES_PATH = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var FILTER_VALUES_PATH = ['filter', 'values'];
exports.FILTER_VALUES_PATH = FILTER_VALUES_PATH;
var SHOW_GROUP_PATH = ['filter', 'values', 0];
exports.SHOW_GROUP_PATH = SHOW_GROUP_PATH;
var SHOW_URL_GROUP_PATH = [].concat(SHOW_GROUP_PATH, ['values', 0]);
exports.SHOW_URL_GROUP_PATH = SHOW_URL_GROUP_PATH;
var SHOW_URL_GROUP_FILTER_PATH = [].concat((0, _toConsumableArray2.default)(SHOW_URL_GROUP_PATH), ['values', 0]);
exports.SHOW_URL_GROUP_FILTER_PATH = SHOW_URL_GROUP_FILTER_PATH;
var HIDE_GROUP_PARENT_PATH = ['filter', 'values', 1];
exports.HIDE_GROUP_PARENT_PATH = HIDE_GROUP_PARENT_PATH;
var HIDE_GROUP_PATH = [].concat(HIDE_GROUP_PARENT_PATH, ['values', 0]);
exports.HIDE_GROUP_PATH = HIDE_GROUP_PATH;